import {CertificateHighlight,PendingHighlight} from './shared/EconomyHighlights';
import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import api from '../services/api';
import { usePermisos } from '../hooks/usePermisos';
import { useModoReducido } from '../hooks/useModoReducido';
import { MenuPageIntro, HeaderIOS, SeccionApps, TarjetaApp, IOS } from './shared/MenuLayout';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement,
  LineElement, Filler, Tooltip as ChartTooltip
} from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, ChartTooltip);

const MID = 5;

const diasRestantes = (fechaFin) => {
  if(!fechaFin) return null;
  const fin = new Date(fechaFin); const hoy = new Date();
  hoy.setHours(0,0,0,0); fin.setHours(0,0,0,0);
  return Math.ceil((fin - hoy) / (1000*60*60*24));
};

const fmtFecha = (s) => {
  if(!s) return '—';
  const d = new Date(s);
  return isNaN(d)?s:d.toLocaleDateString('es-PE',{day:'2-digit',month:'2-digit',year:'numeric'});
};

const Spin = ({color}) => (
  <Box sx={{width:14,height:14,borderRadius:'50%',
    border:`2px solid ${color}30`,borderTopColor:color,
    animation:'spin 0.8s linear infinite',
    '@keyframes spin':{'0%':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}}}}/>
);

const Economia = () => {
  const navigate = useNavigate();
  const { tieneOpcion, cargando } = usePermisos();
  const { opcionEconomiaPermitida } = useModoReducido();
  const user   = authService.getCurrentUser();
  const nc     = user?.nombreCompleto||user?.usuario||'';
  const cap    = t=>t.toLowerCase().split(' ').map(p=>p.charAt(0).toUpperCase()+p.slice(1)).join(' ');
  const nf     = cap(nc);
  const ueId   = user?.ueIdEstablecimiento||user?.UeIdEstablecimiento||0;
  const [hov,setHov] = useState(null);
  const logout = () => { authService.logout(); navigate('/login'); };

  const [certError,setCertError]=useState(false),[pendingError,setPendingError]=useState(false);
  const [cert,setCert]       = useState(null);
  const [pendientes,setPend] = useState([]);
  const [horaNC,setHoraNC]   = useState(null);
  const [cargC,setCargC]     = useState(true);
  const [cargP,setCargP]     = useState(true);
  const [cargNC,setCargNC]   = useState(true);
  const [logNC, setLogNC]   = useState([]);
  const [cargLog, setCargLog] = useState(true);

  useEffect(()=>{
    api.get('/economia/configuracion/certificado',{params:{ueId}})
      .then(r=>{ if(r.data.success&&r.data.data?.length) setCert(r.data.data[0]); })
      .catch(()=>setCertError(true)).finally(()=>setCargC(false));
    api.get('/economia/sunat/pendientes',{params:{ueId}})
      .then(r=>{ if(r.data.success) setPend(r.data.data||[]); })
      .catch(()=>setPendingError(true)).finally(()=>setCargP(false));
    api.get('/economia/configuracion/nota-credito',{params:{ueId}})
      .then(r=>{ if(r.data.success&&r.data.data?.length) setHoraNC(r.data.data[0]?.horA_ENVIO||null); })
      .catch(console.error).finally(()=>setCargNC(false));
    api.get('/economia/notas-credito/log', {params:{ueId}})
  .then(r=>{ if(r.data.success) setLogNC(r.data.data||[]); })
  .catch(console.error).finally(()=>setCargLog(false));
  },[ueId]);

  // Campos exactos del JSON
  const rucVal      = cert?.ruc              || '—';
  const rsVal       = cert?.razoN_SOCIAL     || '—';
  const fechaIniVal = cert?.fechA_INICIO_CERT|| null;
  const fechaFinVal = cert?.fechA_FIN_CERT   || null;
  const dias        = diasRestantes(fechaFinVal);

  const certColor = dias===null?IOS.label2 : dias<=15?IOS.red : dias<=60?IOS.orange : IOS.green;
  const certBg    = dias===null?IOS.bg      : dias<=15?'#FFF0EF' : dias<=60?'#FFF8E6' : '#EDFAF2';
  const certBdr   = dias===null?IOS.separator: dias<=15?'#FFD4D1' : dias<=60?'#FFE9A0' : '#B7EFD0';
  const certLabel = dias===null?'Sin datos'  : dias<=0?'VENCIDO'  : dias<=15?`Vence en ${dias}d ⚠` : dias<=60?`${dias}d restantes` : `Vigente · ${dias}d`;

  const totalPend = pendientes.reduce((a,x)=>a+(Number(x.total??x.TOTAL)||0),0);

  const opciones = [
    {id:'tablero',       n:'Tablero de Control', r:'/economia/tablero'},
    {id:'comprobantes',  n:'Comprobantes',   r:'/economia/comprobantes-pago'},
    {id:'libro-ventas',  n:'Libro de Ventas',r:'/economia/libro-ventas'},
    {id:'consulta-cpe',  n:'Consulta CPE',   r:'/economia/consulta-cpe'},
    {id:'monitor-envios',n:'Monitor Envíos', r:'/economia/monitor-envios'},
    {id:'cuentas-cobrar',n:'Cuentas por Cobrar', r:'/economia/cuentas-por-cobrar'},
    {id:'configuracion', n:'Configuración', r:'/economia/configuracion', icon:'ajustes'},
  ];

  return (
    <Box className="integra-menu" sx={{minHeight:'100vh',bgcolor:IOS.bg}}>
      <HeaderIOS titulo="Economía" subtitulo=""
        onHome={()=>navigate('/dashboard')} onLogout={logout}
        nombreCompleto={nf} avatarLetra={nc.charAt(0).toUpperCase()}/>

      <Box sx={{maxWidth:1400,mx:'auto',px:{xs:2,sm:4},pt:3.5,pb:6}}>
        <Grid container spacing={2.5} className="integra-launcher-layout">

          {/* Izquierda */}
          <Grid item xs={12} lg={8}>
        <MenuPageIntro title="Economía" description="Comprobantes, recaudación y gestión financiera en un solo lugar." />
              <Grid container spacing={1.5}>
                {opciones.map(o=>(
                  <Grid item xs={4} sm={2} key={o.id}>
                    <TarjetaApp id={o.id} nombre={o.n} iconKey={o.icon||o.id} ruta={o.r}
                      bloqueado={(!cargando&&!tieneOpcion(o.id,MID)) || !opcionEconomiaPermitida(o.id)}
                      hoveredId={hov} onHover={setHov} onLeave={()=>setHov(null)}/>
                  </Grid>
                ))}
              </Grid>
          </Grid>

          {/* Derecha — 3 tarjetas */}
          <Grid item xs={12} lg={4} className="integra-launcher-cards economy-widgets" component="aside" aria-label="Resumen del módulo">
            <Box className="integra-launcher-card-group" sx={{display:'flex',flexDirection:'column',gap:1.8}}>

              <CertificateHighlight cert={cert} loading={cargC} error={certError} days={dias} onRenew={()=>navigate('/economia/cotizar-certificado')}/>
              <PendingHighlight items={pendientes} loading={cargP} error={pendingError} enabled={!cargando&&tieneOpcion('monitor-envios',MID)&&opcionEconomiaPermitida('monitor-envios')} onInspect={()=>navigate('/economia/monitor-envios')}/>

              {/* ── 3. Notas de Crédito Automáticas ── */}
<Box className="economy-widget economy-notes" sx={{bgcolor:IOS.surface,borderRadius:'20px',p:2.5,
  border:`1px solid ${IOS.separator}`,
  boxShadow:'0 1px 4px rgba(0,0,0,0.07)'}}>

  {/* Header */}
  <Box sx={{display:'flex',alignItems:'center',gap:1.2,mb:1.8}}>
    <Box sx={{width:44,height:44,borderRadius:'14px',bgcolor:`${IOS.purple}10`,
      display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke={IOS.purple} strokeWidth="1.6" strokeLinecap="round">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="12 6 12 12 16 14"/>
      </svg>
    </Box>
    <Box sx={{flex:1,minWidth:0}}>
      <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,
        textTransform:'uppercase',letterSpacing:'0.08em',mb:0.3}}>
        Notas de Crédito Automáticas
      </Typography>
      {cargNC
        ? <Spin color={IOS.purple}/>
        : <Typography sx={{fontSize:'0.88rem',fontWeight:700,color:IOS.label}}>
            {horaNC||'No configurado'}
          </Typography>
      }
    </Box>
    <Box sx={{px:0.8,py:0.3,borderRadius:'6px',bgcolor:`${IOS.purple}10`,flexShrink:0}}>
      <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.purple}}>Diario</Typography>
    </Box>
  </Box>

  {/* Gráfico sparkline */}
  {cargLog
    ? <Box sx={{display:'flex',justifyContent:'center',py:3}}><Spin color={IOS.purple}/></Box>
    : logNC.length > 0
      ? (() => {
          const ultimos = logNC.slice(-10);
          const labels  = ultimos.map(x=>{
            const f = x.fechaEjecucion||'';
            return f ? f.slice(8,10)+'/'+f.slice(5,7) : '';
          });
          const valores = ultimos.map(x=>Number(x.registrosInsertados||0));
          const maxVal  = Math.max(...valores,1);

          const sparkData = {
            labels,
            datasets:[{
              data: valores,
              borderColor: IOS.purple,
              borderWidth: 2,
              backgroundColor: (ctx)=>{
                if(!ctx.chart.chartArea) return `${IOS.purple}10`;
                const{top,bottom}=ctx.chart.chartArea;
                const g=ctx.chart.ctx.createLinearGradient(0,top,0,bottom);
                g.addColorStop(0,`${IOS.purple}30`);
                g.addColorStop(1,`${IOS.purple}02`);
                return g;
              },
              fill: true,
              tension: 0.45,
              pointRadius: valores.map(v=>v===maxVal?5:2.5),
              pointHoverRadius: 6,
              pointBackgroundColor: valores.map(v=>v===maxVal?IOS.purple:`${IOS.purple}80`),
              pointBorderColor: '#fff',
              pointBorderWidth: 1.5,
            }],
          };

          const sparkOpts = {
            responsive:true, maintainAspectRatio:false,
            animation:{duration:700,easing:'easeOutQuart'},
            plugins:{
              legend:{display:false},
              datalabels:{ display:false },
              tooltip:{
                backgroundColor:'rgba(28,28,30,0.92)',
                titleColor:'#fff', bodyColor:'rgba(255,255,255,0.75)',
                padding:10, borderRadius:10, displayColors:false,
                callbacks:{
                  title: items=>`${items[0].label}`,
                  label: ctx=>` ${ctx.raw} notas generadas`,
                }
              },
            },
            scales:{
              x:{display:true,grid:{display:false},border:{display:false},
                ticks:{font:{size:9},color:IOS.label2,maxRotation:0}},
              y:{display:false, min:0},
            },
            elements:{line:{borderCapStyle:'round'},point:{hoverBorderWidth:2}},
            interaction:{mode:'index',intersect:false},
          };

          return (
            <Box className="economy-notes-chart" sx={{height:90,mb:1.8}}>
              <Line data={sparkData} options={sparkOpts}/>
            </Box>
          );
        })()
      : <Box sx={{py:3,textAlign:'center'}}>
          <Typography sx={{fontSize:'0.75rem',color:IOS.label2}}>Sin registros aún</Typography>
        </Box>
  }

                {/* Último envío */}
                {!cargLog && logNC.length > 0 && (()=>{
                  const ult = logNC[logNC.length-1];
                  const sinNuevas = Number(ult.registrosInsertados||0) === 0;
                  const color  = sinNuevas ? IOS.label2 : IOS.purple;
                  const bg     = sinNuevas ? IOS.bg     : `${IOS.purple}08`;
                  const bdr    = sinNuevas ? IOS.separator : `${IOS.purple}25`;
                  const fecha  = (ult.fechaEjecucion||'').replace('T',' ').slice(0,16);
                  return (
                    <Box className="economy-notes-summary" sx={{p:1.5,bgcolor:bg,borderRadius:'12px',border:`1px solid ${bdr}`}}>
                      <Box sx={{display:'flex',alignItems:'center',justifyContent:'space-between',mb:0.8}}>
                        <Typography sx={{fontSize: '0.72rem',fontWeight:700,color,
                          textTransform:'uppercase',letterSpacing:'0.06em'}}>
                          Último envío
                        </Typography>
                        <Typography sx={{fontSize: '0.72rem',color:IOS.label2,fontFamily:'monospace'}}>
                          {fecha}
                        </Typography>
                      </Box>
                      <Typography sx={{fontSize:'0.78rem',fontWeight:600,color:IOS.label,mb:0.5}}>
                        {ult.mensaje}
                      </Typography>
                      <Box sx={{display:'flex',gap:1}}>
                        <Box sx={{px:0.8,py:0.25,borderRadius:'6px',
                          bgcolor:sinNuevas?IOS.separator+'30':`${IOS.purple}15`}}>
                          <Typography sx={{fontSize: '0.72rem',fontWeight:700,
                            color:sinNuevas?IOS.label2:IOS.purple}}>
                            {ult.registrosInsertados} notas
                          </Typography>
                        </Box>
                        <Box sx={{px:0.8,py:0.25,borderRadius:'6px',
                          bgcolor:sinNuevas?IOS.separator+'30':`${IOS.purple}15`}}>
                          <Typography sx={{fontSize: '0.72rem',fontWeight:700,
                            color:sinNuevas?IOS.label2:IOS.purple}}>
                            {ult.seriesAfectadas} series
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  );
                })()}

              </Box>

            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Economia;
